import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { OTHER_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ExportIncomeYearFieldsPct from './ExportIncomeYearFieldsPct';

const ExportIncomeOtherPct = () => {
  const { exportIncome } = useIncomeStructure();

  const otherExportIncomePct = findMasterDataById(
    exportIncome,
    OTHER_INCOME_STRUCTURE_ID.OTHER_EXPORT_INCOME
  );

  return (
    <>
      {otherExportIncomePct && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right' }}>
              {otherExportIncomePct.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ExportIncomeYearFieldsPct
            keyItem={otherExportIncomePct.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ExportIncomeOtherPct;
